export enum AddressType {
  billing = 'billing',
  shipping = 'shipping',
  same = 'same'
}
